import { CSSProperties, useMemo } from 'react';
import { SiteContext } from '../SiteContext';
import useContext from './useContext';

const useTheme = (theme?: string) => {
  const { data } = useContext(SiteContext);

  if (!theme) {
    return undefined;
  }

  return data?.themes?.[theme];
};

export const useHeroContentTheme = (themeName: string) => {
  const theme = useTheme(themeName);

  return useMemo(
    () =>
      ({
        backgroundColor: theme?.backgroundColor,
        color: theme?.textColor,
      }) as CSSProperties,
    [theme],
  );
};

export const useHeroButtonTheme = (themeName: string) => {
  const theme = useTheme(themeName);

  return useMemo(
    () =>
      ({
        backgroundColor: theme?.btnBackgroundColor,
        color: theme?.btnTextColor,
        borderColor: theme?.btnBorderColor,
      }) as CSSProperties,
    [theme],
  );
};
